import React from 'react';
import { Input } from 'antd';
import Button from '@/components/button/Button';
import loginUserIcon from '../assets/login-user.png';
import failReg from '@/assets/icons/failReg.webp';
import styles from '../LoginModal.module.scss';

const LegacyVerifyForm = ({
  verifyResult,
  showVerifyCode,
  isForgotPassword,
  phoneNumber,
  onPhoneNumberChange,
  verifyCode,
  countdown,
  verifyInputRefs,
  onVerifyCodeChange,
  onVerifyCodeKeyDown,
  onVerifyCodePaste,
  onSendVerifyCode,
  onBack,
  loadingStates,
}) => {
  const getTitleText = () => {
    if (verifyResult === 'reset_password') return '设置新密码';
    if (showVerifyCode) return '请输入验证码';
    if (isForgotPassword) return '找回密码';
    return '验证您的身份';
  };

  return (
    <>
      <div className={styles.verifyTitle}>
        <Button type="text-back" onClick={onBack} />
        <div className={styles.titleText}>{getTitleText()}</div>
      </div>

      {verifyResult === 'reset_password' ? null : (
        <div className={styles.verifyLoginForm}>
          {!showVerifyCode ? (
            <>
              <div className={styles.phoneInputContainer}>
                <div className={styles.userIcon}>
                  <img src={loginUserIcon} alt="" />
                </div>
                <Input
                  placeholder="请输入您的手机号或邮箱"
                  className={styles.phoneInput}
                  value={phoneNumber}
                  onChange={(e) => onPhoneNumberChange(e.target.value)}
                />
              </div>

              <button
                className={`${styles.loginBtn} ${!phoneNumber.trim() ? styles.disabled : ''}`}
                onClick={onSendVerifyCode}
                disabled={!phoneNumber.trim()}
              >
                {loadingStates.sendEmail || loadingStates.sendCode ? (
                  <div className={styles.buttonLoading}>
                    <div className={styles.spinner} />
                  </div>
                ) : (
                  '下一步'
                )}
              </button>
            </>
          ) : verifyResult ? (
            <div className={styles.verifyResult}>
              <div className={styles.resultIcon}>
                {verifyResult === 'fail' && <img src={failReg} alt="" />}
              </div>
              <div className={styles.resultText}>
                {verifyResult === 'fail' ? '注册失败' : ''}
              </div>
              {verifyResult === 'fail' && (
                <button
                  className={styles.loginBtn}
                  onClick={() => {
                    onBack();
                  }}
                >
                  重新注册
                </button>
              )}
            </div>
          ) : (
            <div className={styles.verifyCodeSection}>
              <div className={styles.verifyCodeTip}>
                <span className={styles.phoneNumber}>{phoneNumber}</span>
                的6位验证码
              </div>
              <div className={styles.verifyCodeInput}>
                {verifyCode.map((code, index) => (
                  <Input
                    key={index}
                    ref={(el) => (verifyInputRefs.current[index] = el)}
                    value={code}
                    onChange={(e) => onVerifyCodeChange(index, e.target.value)}
                    onKeyDown={(e) => onVerifyCodeKeyDown(index, e)}
                    onPaste={index === 0 ? onVerifyCodePaste : undefined}
                    maxLength={1}
                    onFocus={() => {
                      const firstEmptyIndex = verifyCode.findIndex((c) => !c);
                      if (firstEmptyIndex !== -1 && index > firstEmptyIndex) {
                        verifyInputRefs.current[firstEmptyIndex]?.focus();
                      }
                    }}
                  />
                ))}
              </div>
              <div
                className={`${styles.verifyCodeResend} ${countdown > 0 ? styles.disabled : ''}`}
                onClick={() => {
                  if (countdown === 0) {
                    onSendVerifyCode();
                  }
                }}
              >
                {countdown > 0
                  ? `(${countdown}s)重新发送验证码`
                  : '重新发送验证码'}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LegacyVerifyForm;
